import { UserIcon } from 'de-suite-me-ui'

export default UserIcon
